import React from "react";
import "./Core.css";

import li1 from './../images/li1.svg';
import li2 from './../images/li2.svg';
import li3 from './../images/li3.svg';
import ri1 from './../images/ri1.svg';
import ri2 from './../images/ri2.svg';
import ri3 from './../images/ri3.svg';
import ri11 from './../images/ri11.svg';
import ri12 from './../images/ri12.svg';
import ri13 from './../images/ri13.svg';
const Core = () => {
  return (
    <div className="container">
      <div className="core-details">
        <div className="core">
          <div className="left-captions">
            <div className="first-core">
              <div className="first-img">
                <img src={li1} alt="img" />
              </div>
            </div>
          </div>
          <div className="left-captions">
            <div className="first-core">
              <div className="first-img">
                <img src={li2} alt="img" />
              </div>
            </div>
          </div>
          <div className="left-captions">
            <div className="first-core">
              <div className="first-img">
                <img src={li3} alt="img" />
              </div>
            </div>
          </div>
          <div className="left-captions">
            <div className="first-core">
              <div className="first-img">
                <img src={ri1} alt="img" />
              </div>
            </div>
          </div>
          <div className="left-captions">
            <div className="first-core">
              <div className="first-img">
                <img src={ri2} alt="img" />
              </div>
            </div>
          </div>
          <div className="left-captions">
            <div className="first-core">
              <div className="first-img">
                <img src={ri3} alt="img" />
              </div>
            </div>
          </div>
        </div>
        <div className="core-mobile">
          <div className="row">
            <div className="col-md-6">
              <div className="left-captions">
                <div className="first-core">
                  <div className="first-img">
                    <img src={li1} alt="img" />
                  </div>
                </div>
                <div className="left-captions">
                  <div className="first-core">
                    <div className="first-img">
                      <img src={li2} alt="img" />
                    </div>
                  </div>
                </div>
                <div className="left-captions">
                  <div className="first-core">
                    <div className="first-img">
                      <img src={li3} alt="img" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
            <div className="left-captions">
            <div className="first-core">
                    <div className="first-img">
                      <img src={ri11} alt="img" />
                    </div>
                  </div>
          </div>
          <div className="left-captions">
          <div className="first-core">
                    <div className="first-img">
                      <img src={ri12} alt="img" />
                    </div>
                  </div>
          </div>
          <div className="left-captions">
          <div className="first-core">
                    <div className="first-img">
                      <img src={ri13} alt="img" />
                    </div>
                  </div>
          </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Core;
